<template>
  <label class="multi-select" ref="dropdown">
    <button
      type="button"
      class="select-button"
      @click.stop="toggleDropdown"
    >
      <span>{{ selectedLabel }}</span>
    </button>

    <div
      v-if="open"
      class="options"
      @click.stop
    >
      <label
        v-for="option in options"
        :key="option.id"
        class="option"
      >
        <input
          type="checkbox"
          :value="option.name"
          v-model="selected"
        >

        {{ option.name }}
      </label>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    header: {
      type: String
    },

    options: {
      type: Array,
      default: function () {
        return []
      }
    },

    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },

  data() {
    return {
      open: false
    }
  },

  computed: {
    selected: {
        get() {
        if (!this.value) {
            return []
        }

        return this.value
            .split(',')
            .filter(Boolean)
        },

        set(value) {
        this.$emit('input', value.join(','))
        }
    },

    selectedLabel() {
        if (!this.selected.length) {
            return this.header
        }

        return this.options
        .filter(option => this.selected.indexOf(option.name) !== -1)
        .map(option => option.name)
        .join(', ')
    }
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },

  methods: {
    toggleDropdown() {
      this.open = !this.open
    },

    handleOutsideClick(event) {
      if (
        this.$refs.dropdown &&
        !this.$refs.dropdown.contains(event.target)
      ) {
        this.open = false
      }
    }
  }
}
</script>

<style scoped>
.multi-select {
    position: relative;
}

.select-button {
    padding: .75rem 1.75rem .75rem .25rem;
    border: 1px solid #707070;
    border-radius: .25rem;
    -webkit-appearance: none;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAABHNCSVQICAgIfAhkiAAAANlJREFUKFNjZACCvLy8SiYmpjYQmxzw79+/zZMmTfID6WUEEfn5+R2MjIx5QCYnqQb+////N1DPpYkTJ5rADYQaugxoqC+QzUOsoUDDfgHxA6DvzCdMmPABxUByDAV69RayYRgGQsNzE1CRO5DNhs+lQJc9BvpID+YymFpwGCKDgoICAaDNJ4GGKuAyFGjYd6BhVkDDLqDrxzAQpACfofgMw+plmI0wQ4EukQdidpA4IcPwGojmUjWgYW+BBrtg8yayt7F6GT1MgYa1Aw2bScgwgi4kNj0iqwMAh6NoDMohUA4AAAAASUVORK5CYII=);
    background-position: calc(100% - .25rem) center;
    background-repeat: no-repeat;
    min-width: 220px;
    max-width: 220px;
    width: 100%;
    font-size: .8rem;
    text-align: left;
    font-weight: 400;
    overflow: hidden;
}
.select-button:hover {
    color: #000;
}

.select-button span {
    max-width: 100%;
    width: 100%;
    display: block;
    min-width: 100%;
    white-space: nowrap;
    overflow: hidden;
}

.options {
  position: absolute;
  z-index: 1000;
  margin-top: 4px;
  padding: 6px 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  left: 0px;
  right: .5rem;
}

.option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
}
.option:hover {
    background-color: #f5f5f5;
}
</style>